import gql from 'graphql-tag';

export default gql`
  fragment ConnectedEmailFields on ConnectedEmail {
    email
    syncState
  }
`;
